import { useTranslation } from 'react-i18next';
import UtilityDrawerBody from '../utility-drawer/utility-drawer-body/utility-drawer-body.component';
import UtilityDrawer from '../utility-drawer/utility-drawer.component';
import LocationLoyaltyTrendsApiDefinitions from './location-loyalty-trends-api-definitions/location-loyalty-trends-api-definitions.component';

type LocationLoyaltyTrendsAPIDetailsDrawerProps = {
  isOpen: boolean;
  close: () => void;
};

const LocationLoyaltyTrendsAPIDetailsDrawer = ({
  isOpen,
  close,
}: LocationLoyaltyTrendsAPIDetailsDrawerProps) => {
  const { t } = useTranslation();
  return (
    <UtilityDrawer
      open={isOpen}
      onClose={close}
      title={t(
        'page.loyaltyPerformanceReport.tabs.locationLoyaltyTrends.label',
      )}
    >
      <UtilityDrawerBody>
        <LocationLoyaltyTrendsApiDefinitions />
      </UtilityDrawerBody>
    </UtilityDrawer>
  );
};

export default LocationLoyaltyTrendsAPIDetailsDrawer;
